import { FC, useEffect, useState } from "react";
import { LangKey, useTranslation } from "@vixi/localization";

interface AlternatingMessagesProps {
  messages: LangKey[];
  interval?: number;
  complete?: boolean;
  completeMessage?: LangKey;
}

export const AlternatingMessages: FC<AlternatingMessagesProps> = ({
  messages,
  complete = false,
  completeMessage,
  interval: timeInterval = 10,
}) => {
  const { t } = useTranslation();
  const [messageIndex, setMessageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setMessageIndex((prev) => (prev + 1) % messages.length);
    }, 1000 * timeInterval);
    return () => clearInterval(interval);
  }, []);

  if (complete) {
    if (!completeMessage) return null;
    return t(completeMessage);
  }

  return t(messages[messageIndex]);
};
